import React, { ReactElement } from 'react';

import CloseIcon from 'components/Icons/CloseIcon';
import ArrowLeftIcon from 'components/Icons/ArrowLeftIcon';
import Text from 'components/Text';
import { classNames } from 'utils/css';

import { ACTION_COLORS, TITLE_COLORS } from './TopBar.constants';
import { TTopBarProps } from './TopBar.types';
import styles from './TopBar.module.scss';

// TODO: Combine isRootPage and noAction into one prop (union)?
function TopBar({
  title,
  onActionButtonClick,
  rightContent,
  isRootPage,
  colorVariant = 'light',
  noAction = false,
}: TTopBarProps): ReactElement {
  const isDarkMode = colorVariant === 'dark';
  const ActionIcon = isRootPage ? CloseIcon : ArrowLeftIcon;

  return (
    <header
      className={classNames(styles.header, isDarkMode && styles.dark)}
      role="banner"
      data-testid="TopBar">
      {!noAction && (
        <div
          className={styles.actionButton}
          role="button"
          aria-hidden="true"
          data-testid="TopBarAction"
          onClick={onActionButtonClick}>
          <ActionIcon iconColor={ACTION_COLORS[colorVariant]} />
        </div>
      )}
      <div className={styles.headerContent}>
        <Text
          as="div"
          size="large"
          weight="semiBold"
          color={TITLE_COLORS[colorVariant]}>
          {title}
        </Text>
      </div>
      <div className={styles.suffix} data-testid="TopBarSuffix">
        {rightContent}
      </div>
    </header>
  );
}

export default TopBar;
